import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './Dashboard.css';

const Dashboard = () => {
    const [startDate, setStartDate] = useState(new Date());

    const topItemsData = [
        { name: 'SILVER', quantity: 20, amount: '$91.40' },
        { name: 'MONTEGO MENTHOL GOLD KING', quantity: 18, amount: '$90.00' },
        { name: 'SONOMA RED', quantity: 12, amount: '$75.00' },
        { name: 'SKOAL', quantity: 5, amount: '$34.60' },
        { name: 'GRIZZLY', quantity: 5, amount: '$31.85' },
        { name: 'SONOMA GOLD 100', quantity: 5, amount: '$31.35' },
        { name: 'MARLBORO GOLD', quantity: 2, amount: '$20.38' },
        { name: 'MARLBORO RED', quantity: 3, amount: '$18.75' }
    ];

    const chartData = [
        { day: 'SUN', value: 85 },
        { day: 'MON', value: 90 },
        { day: 'TUE', value: 70 },
        { day: 'WED', value: 80 },
        { day: 'THU', value: 65 },
        { day: 'FRI', value: 75 },
        { day: 'SAT', value: 85 }
    ];

    return (
        <div className="responsive-box">
            <div className="dashboard-header">
                <h1 className="dashboard-title">Report</h1>

                <div className="dashboard-header-right">
                    <div className="dashboard-header-title">
                        <h1>Marion-Sunoco-Gas-Station-0290</h1>
                        <ChevronRight size={20} className="dashboard-chevron-icon" />
                    </div>

                    <div className="dashboard-date-picker-container">
                        <span className="calendar-icon">📅</span>
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            className="date-input"
                            dateFormat="MMM d, yyyy"
                        />
                    </div>
                </div>
            </div>

            <div className="dashboard-box">
                <div className="dashboard-stats">
                    <div className="dashboard-card sales">
                        <div className="stat-header">
                            <div className="stat-icon">📊</div>
                            <h3>Sales</h3>
                        </div>
                        <div className="stat-footer">
                            <div className="stat-block">
                                <div className="stat-value">$438749</div>
                                <div className="stat-label-title">Amount</div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-label">234</div>
                                <div className="stat-label-title">Count</div>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-card fuel">
                        <div className="stat-header">
                            <div className="stat-icon">⛽</div>
                            <h3>Fuel</h3>
                        </div>
                        <div className="stat-footer">
                            <div className="stat-block">
                                <div className="stat-value">$368.70</div>
                                <div className="stat-label-title">Amount</div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-label">127</div>
                                <div className="stat-label-title">Gallons</div>

                            </div>
                        </div>
                    </div>

                    <div className="dashboard-card no-sale">
                        <div className="stat-header">
                            <div className="stat-icon">🚫</div>
                            <h3>No Sale</h3>
                        </div>
                        <div className="stat-footer">
                            <div className="stat-block">
                                <div className="stat-value">$112.15</div>
                                <div className="stat-label-title">Amount</div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-label">273</div>
                                <div className="stat-label-title">Count</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="dashboard-content">
                    {/* Chart Section */}
                  <div className="dashboard-charts">
            <div className="chart-header">
              <div className="chart-tabs-left">
                <button className="tab active">Sales</button>
                <button className="tab">Fuel Sold</button>
              </div>

              <div className="chart-period-bottom">
                <span className="period-btn active">This week</span>
                <span className="period-btn">Last week</span>
              </div>
            </div>

            <div className="chart-con">
              <div className="chart-y-axis">
                <div>80</div>
                <div>60</div>
                <div>40</div>
                <div>20</div>
                <div>0</div>
              </div>
              <div className="chart-bars">
                {chartData.map((item, index) => (
                  <div key={index} className="bar-container">
                    <div
                      className="bar"
                      style={{ height: `${item.value}%` }}
                    ></div>
                    <div className="bar-label">{item.day}</div>
                  </div>
                ))}
              </div>
              <div className="chart-baseline" />
            </div>
          </div>

          {/* Top Items Section */}
          <div className="dashboard-top-items">
            <h3>Top 8 Items</h3>
            <div className="items-header">
              <span>Item</span>
              <span>Qty</span>
              <span>Amount</span>
            </div>
            <div className="items-list">
              {topItemsData.map((item, index) => (
                <div key={index} className="item-row">
                  <div className="itemname">{item.name}</div>
                  <div className="item-qty">{item.quantity}</div>
                  <div className="item-amount">{item.amount}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
